/**
 * Checks if a block should be shown or not considering the old engine (uischema.options.display),
 * or the new engine (isShown from the store).
 *
 * @example
 * shouldShowBlock(uischema.options.display, isShown)
 */
export const shouldShowBlock = (
  uischemaDisplay?: boolean,
  isShown?: boolean
) => {
  if (
    typeof isShown === 'undefined' // In the old engine, the isShown is undefined
      ? uischemaDisplay === false // Use old engine display option
      : !isShown // use the display condition from the store (new engine)
  ) {
    return false
  }

  return true
}
